import React, { useState } from 'react';
import { View, Text, TouchableOpacity, Platform, StyleSheet } from 'react-native';
import styles from '../../style/productdetail';

const DimensionUnitDropdown = ({
  onChangeUnit,
  dimensionUnit,
  label,
  style,
  truncateLabel = false
}) => {
  const [dropdownOpen, setDropdownOpen] = useState(false);

  const dimensionUnitOptions = [
    { label: 'Inches', value: 'inches' },
    { label: 'Centimeters', value: 'centimeter' }
  ];

  const handleUnitSelect = (unit) => {
    onChangeUnit(unit);
    setDropdownOpen(false);
  };

  return (
    <View style={[styles.viewGap, style]}>
      <Text style={[
        styles.productInfoText, 
        truncateLabel && localStyles.truncatedText
      ]}>
        {label}
      </Text>
      <View style={localStyles.dropdownContainer}>
          <select
            style={localStyles.webSelect}
            value={dimensionUnit || 'inches'}
            onChange={(event) => handleUnitSelect(event.target.value)}
          >
            {dimensionUnitOptions.map((option) => (
              <option
                key={option.value}
                value={option.value}
                style={localStyles.webOption}
              >
                {option.label}
              </option>
            ))}
          </select>
      </View>
    </View>
  );
};

const localStyles = StyleSheet.create({
  dropdownContainer: {
    position: 'relative',
    zIndex: 10
  },
  truncatedText: {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    maxWidth: '100%'
  },
  webSelect: {
    cursor: 'pointer',
    width: '100%',
    height: 35,
    backgroundColor: 'transparent',
    borderTopWidth: 0,
    borderLeftWidth: 0,
    borderRightWidth: 0,
    borderBottomWidth: 0.5,
    borderBottomColor: '#fff',
    color: '#fff',
    fontSize: 14,
    fontFamily: 'inherit',
    outline: 'none'
  },
  webOption: {
    backgroundColor: '#333',
    color: '#fff',
    padding: 5
  },
  dropdownItem: {
    padding: 10
  }
});

export default DimensionUnitDropdown;
